import Overview from "@/components/admin/Content/WebPages/Events/Overview";
import HeroSection from "@/components/admin/Content/WebPages/Events/HeroSection";
import FullPageSpinner from "@/components/ui/FullPageSpinner";
import { useWebPageForm } from "@/contexts/WebPageFormContext";

const Events = () => {
  const { pageData, isLoading } = useWebPageForm();

  if (isLoading) {
    return <FullPageSpinner />;
  }

  return (
    <div className="flex flex-col gap-8 lg:gap-12 p-4 md:p-8 lg:p-12 xl:w-3/4 mx-auto">
      <HeroSection data={pageData?.EVENT_BANNER ?? {
        sectionTag: 'EVENT_BANNER',
        contentType: 'WITH_FILE',
        title: 'Events Banner'
      }} />
      <Overview data={pageData?.EVENT ?? {
        sectionTag: 'EVENT',
        contentType: 'WITHOUT_FILE',
        title: 'Our Events'
      }} />
    </div>
  )
}

export default Events